import { render } from "./trust-admin-main.html?vue&type=template&id=9bff0fdc&scoped=true&ts=true&external"
import script from "./trust-admin-main.ts?vue&type=script&lang=ts&external"
export * from "./trust-admin-main.ts?vue&type=script&lang=ts&external"

import "./trust-admin-main.scss?vue&type=style&index=0&id=9bff0fdc&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bff0fdc"]])

export default __exports__